<template>
	<div id="app" class="app" :class="theme">
		<hyper-cloud-console-vue
			:autoOpen="autoOpen"
			:hideControls="hideControls"
			:customui="onPublicPage"
			:class="{ invisible: !isAuthenticated }"
			ref="console"
		/>
		<navigation v-if="!loading && isAuthenticated" :paddingLeft="navPadding" />
		<router-view v-if="!loading" />
		<spinner v-else />
		<error-dialog ref="errDialog" />
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import HyperCloudConsoleVue from './components/shared/HyperCloudConsoleVue';
import ErrorDialog from './components/shared/ErrorDialog';
import Spinner from './components/shared/Spinner';
import Navigation from './components/core/Navigation.vue';
import ThemeService from './services/theme';
import ConsoleService from './services/console';

import {
	enable as enableDarkMode,
	disable as disableDarkMode,
	setFetchMethod,
} from 'darkreader';

export default {
	name: 'app',
	components: {
		HyperCloudConsoleVue,
		Navigation,
		ErrorDialog,
		Spinner,
	},
	data() {
		return {
			theme: 'light',
			hideControls: true,
			autoOpen: false,
			onPublicPage: true,
			loading: true,
			navPadding: false,
		};
	},
	computed: {
		...mapGetters(['isAuthenticated']),
		...mapGetters(['isDeveloper']),
	},
	created() {
		this.$store.state.consoleReady$.promise.then(() => (this.loading = false));
		this.listenForThemeChanges();
	},
	methods: {
		...mapActions({
			fetchUsage: 'fetchUsage',
			fetchArticles: 'fetchArticles',
			fetchServices: 'fetchServices',
			fetchVirtualCash: 'fetchVirtualCash',
		}),
		onAuthenticated() {
			this.fetchUsage();
			this.fetchArticles();
			this.fetchServices();
			this.fetchVirtualCash();
			this.rerouteOnLogin();
		},
		async rerouteOnLogin() {
			if (this.$route.path !== '/console/login') {
				return;
			}
			const nextPath =
				this.$route.query.next && decodeURI(this.$route.query.next);
			if (nextPath && nextPath !== '/console') {
				return this.$router.push(decodeURI(this.$route.query.next));
			} else {
				return this.$router.push({ name: 'ConsoleDashboard' });
			}
		},
		listenForThemeChanges() {
			ThemeService.instance().events.on('themechanged', () => {
				this.theme = ThemeService.instance().getTheme();
				if (this.theme == 'dark') {
					setFetchMethod(window.fetch);
					enableDarkMode({
						brightness: 100,
						contrast: 90,
						sepia: 10,
					});
				} else {
					disableDarkMode();
				}
			});
		},
	},
	watch: {
		$route(to) {
			if (to.path === '/console/' || to.path === '/console') {
				this.hideControls = false;
				this.autoOpen = true;
				if (ConsoleService.instance().maybeExpandSidenav()) {
					this.navPadding = true;
				}
			} else {
				this.hideControls = true;
				this.autoOpen = false;

				if (ConsoleService.instance().maybeCollapseSidenav()) {
					this.navPadding = false;
				}
			}
			this.onPublicPage = to.meta.access === 'PUBLIC';
		},
		isAuthenticated(isAuthenticated) {
			if (isAuthenticated) {
				this.onAuthenticated();
			}
		},
	},
};
</script>

<style>
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';

@import '~hyper-bootstrap/bootstrap-override.css';
</style>
